"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItemSecondaryAction = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var _customComponents = require("../../../../utils/customComponents");

/* istanbul ignore next */
var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
});
/* istanbul ignore next */

var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
/* istanbul ignore next */

var IconButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/templates/IconButtonDialog/IconButtonDialog"));
  });
});
var components = {
  IconButtonRedirect: IconButtonRedirect,
  IconButtonDownload: IconButtonDownload,
  IconButtonDialog: IconButtonDialog
};
/**
 * ListItemSecondaryAction is used in storyblok redirect to react routes
 */

var ListItemSecondaryAction = function ListItemSecondaryAction(_ref) {
  var content = _ref.content,
      rootClass = _ref.rootClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, {
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, (0, _customComponents.renderComponentsWithBridge)(components, content[0])));
};

exports.ListItemSecondaryAction = ListItemSecondaryAction;
var _default = ListItemSecondaryAction;
exports.default = _default;
ListItemSecondaryAction.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * components:
    *  Allowed maximum: 1 */
  content: function content(props, propName, componentName) {
    var comp = ['IconButtonRedirect', 'IconButtonHref', 'IconButtonDownload', 'IconButtonDialog'];
    return (0, _customProps.validComponents)(props, propName, componentName, comp, 1);
  },

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
ListItemSecondaryAction.defaultProps = {
  rootClass: [],
  content: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};